const commonStyle = {
  borderRadius: "5px",
  padding: "4px 4px",
  textAlign: "center",
  width: "auto",
  fontSize: "80%",
  fontWeight: "500",
  whiteSpace: "nowrap",
  textTransform: "capitalize",
};

const approved = {
  backgroundColor: "#E7FAE3",
  color: "#2D6040",
  border: "1px solid #E7FAE3",
};

const rejected = {
  backgroundColor: "#F5CFD3",
  color: "#671A21",
  border: "1px solid  #F5CFD3",
};
const created = {
  backgroundColor: "#F5F2CF",
  color: "#6B5C1F",
  border: "1px solid #F5F2CF",
};

const pending = {
  backgroundColor: "gray",
  color: "#FFFFFF",
  border: "1px solid gray",
};

const interested = {
  backgroundColor: "#cad7ff",
  color: "#6d91ff",
  border: "1px solid #cad7ff",
  cursor: "pointer"
};

const approveDs = {
  backgroundColor: "#00865F",
  color: "#FFFFFF",
  border: "1px solid #00865F",
};

const rejectedDs = {
  backgroundColor: "#C9171F",
  color: "#FFFFFF",
  border: "1px solid  #C9171F",
};

const draft = {
  backgroundColor: "#A1A3AC",
  color: "#FFFFFF",
  border: "1px solid #A1A3AC",
};

const submitted = {
  backgroundColor: "#FBC02D",
  color: "#000",
  border: "1px solid #FBC02D",
};

const reserved = {
  backgroundColor: "#edd4ff",
  color: "#4B0081",
  border: "1px solid #edd4ff",
};

const underReview = {
  backgroundColor: "#0970D4",
  color: "#FFFFFF",
  border: "1px solid #0970D4",
};

const needResubmit = {
  backgroundColor: "#8E24AA",
  color: "#FFFFFF",
  border: "1px solid #8E24AA",
};

const resubmit = {
  backgroundColor: "#008FF6",
  color: "#FFFFFF",
  border: "1px solid #008FF6",
};

const conditionallyApproved = {
  backgroundColor: "#66BB6A",
  color: "#fff",
  border: "1px solid #66BB6A",
};

export const handleStatusesBadge = (status) => {
  if (status) {
    switch (status) {
      case "assigned":
      case "reassigned":
      case "pending":
      case "PENDING":
      case "SCHEDULED":
      case "waiting":
        return { ...commonStyle, ...pending };
      case "not_approved":
      case "cancelled":
      case "failed":
      case "blocked":
      case "payment_failed":
      case "inactive":
      case "offboarded":
      case "rejected":
      case "FAILED":
      case "CANCELED":
        return { ...commonStyle, ...rejected };
      case "processed":
      case "paid":
      case "complete":
      case "confirmed":
      case "done":
      case "approved" || "Waiting For Approval":
      case "COMPLETED":
        return { ...commonStyle, ...approved };
      case "delivery_started":
      case "Delivery Started":
      case "created":
      case "reopened":
      case "suspended":
      case "other":
        return { ...commonStyle, ...created };
      case "remain":
        return { ...commonStyle, ...rejected };
      case "reserved":
        return { ...commonStyle, ...reserved };
      case "interested": //from API it's interestedDriver
      case "sort_interested": //from API it's interestedDriver
        return { ...commonStyle, ...interested };
      case "interested":
        return { ...commonStyle, ...interested };
      case "pickup_interested":
        return { ...commonStyle, ...interested };
      case "sort_assigned":
        return { ...commonStyle, ...pending };
      case "pickup_assigned":
        return { ...commonStyle, ...pending };
      case "contractor_assigned":
        return { ...commonStyle, ...pending };
      case "Created":
        return { ...commonStyle, ...created };
      // case "Waiting For Approval":
      //   return { ...commonStyle, ...pending }
      case "Approved":
        return { ...commonStyle, ...pending };
      default:
        return commonStyle;
    }
  }
};

export const handleDriverStatusesBadge = (status) => {
  if (status) {
    switch (status) {
      case "approved":
        return { ...commonStyle, ...approveDs };
      case "draft":
        return { ...commonStyle, ...draft };
      case "submitted":
        return { ...commonStyle, ...submitted };
      case "under_review":
        return { ...commonStyle, ...underReview };
      case "needs_resubmission":
        return { ...commonStyle, ...needResubmit };
      case "resubmitted":
        return { ...commonStyle, ...resubmit };
      case "conditionally_approved":
        return { ...commonStyle, ...conditionallyApproved };
      case "rejected":
        return { ...commonStyle, ...rejectedDs };
      case "suspended":
        return { ...commonStyle, ...created };
      case "waiting":
        return { ...commonStyle, ...pending };
      case "not_approved":
      case "offboarded":
      case "inactive":
        return { ...commonStyle, ...rejected };
      default:
        return commonStyle;
    }
  }
};

export const handleProspectStatusesBadge = (status) => {
  switch (status) {
    case "sent":
      return { ...commonStyle, ...approved };
    case "not_sent":
      return { ...commonStyle, ...rejected };
    default:
      return commonStyle;
  }
}

export const handleCampaignReportStatusesBadge = (status) => {
  switch (status) {
    case "In Progress":
      return { ...commonStyle, ...created };
    case "Failed":
    case "Expired":
      return { ...commonStyle, ...rejected };
    case "Paid":
    case "Eligible":
      return { ...commonStyle, ...approved };
    default:
      return commonStyle;
  }
}

export const handleBackgroundCheck = (status) => {
  if (status) {
    return { ...commonStyle, ...approved };
  } else {
    return { ...commonStyle, ...rejected };
  }
}

export const handleBackgroundStatusesBadge = (status) => {
  if (status) {
    switch (status) {
      case "clear":
        return { ...commonStyle, ...approved };
      case "complete":
        return { ...commonStyle, ...approved };
      case "pending":
        return { ...commonStyle, ...created };
      case "created":
        return { ...commonStyle, ...created };
      case "consider":
        return { ...commonStyle, ...rejected };
      case "suspended":
        return { ...commonStyle, ...rejected };
      case "dispute":
        return { ...commonStyle, ...rejected };
      case "canceled":
        return { ...commonStyle, ...rejected };
      default:
        return commonStyle;
    }
  }
};

export const checkForIsDriverNew = (orderCount) => {
  if (!orderCount) return false;
  if (orderCount > 3) return true;
  return false;
};
